//@ts-check

/*


    {
        is : E1, E2, E3,...  D , F3, F2, F1
    }


*/
const PrepareEtatItem = function (row, paramArgs, tri, is, index) {
    //
    let args;
    //
    if (is) { // is Bloc header ou footer
        const char = (is == "A") ? "" : '\uFFFF';
        args = paramArgs.map((arg, i) => (i > index) ? char : arg) // copie du tableau
    } else {
        args = paramArgs;
    }
    return {
        is: (is) ? is + index : "DATA",
        args: args,
        tri: tri,
        data: row,
    }
}

class FilterList {
    constructor(index, u, parent) {
        this.index = index;
        this.val = (typeof u === 'function') ? u : function (x) { return x[u] };
        this.parent = parent;
        this.checked = [];
    }
    setChecked(checked) {
        this.checked = Array.from(checked);
        this.parent.actualise(this.index);
    }
    getChecked() {
        return this.checked;
    }
    value(row) {
        return this.val(row);
    }
    test(row) {
        if (this.checked.length === 0 ) return true;
        //console.log ("this.checked", this.checked ,this.val(row) )
        return (this.checked.indexOf(this.val(row)) >= 0);
        //return (this.checked.length === 0 || this.checked.indexOf(this.val(row)) >= 0);
    }
    valeursPossibles() {
        const set = new Set();

        this.parent.eachSaufColumn(this.index, row => set.add(this.value(row)))
        return Array.from(set).sort();
    }

}




class JeuDeDonnees {
    constructor(rows) {
        this.rows = rows.map(row => ({ data: row, tests: [] }));
        this.filters = [];
        this.filterUse = null;
        this.estFiltre = false;
    }
    /**
     * 
     * @param {*} fonction soit un fonction soit une chaine donnant le nom du champ dans le jeu de données
     * @returns objet filter
     */
    addFilterList(fonction) {
        const index = this.filters.length;
        const filter = new FilterList(index, fonction, this);
        this.filters.push(filter);
        return filter;
    }


    actualiseTous() {
        for (const row of this.rows) {
            row.tests = this.filters.map(filter => (filter.test(row.data)));// tableau de booléen donnant la valeur de chaque filtre
        }
    }
    actualise(index) {
        for (const row of this.rows) {
            row.tests[index] = this.filters[index].test(row.data);   // Actualise les valeurs d'un filtre pour chaque enregistrement
        }
    }
    getRows() {
        if (!this.estFiltre) {
            this.estFiltre = true;
            this.actualiseTous();
        }
        function testTous(array) {
            for (let a of array) if (!a) return;
            return true;
        }
        return this.rows.filter(u => testTous(u.tests)).map(u => u.data);
    }
    eachSaufColumn(index, each) {


        function testTousSauf(array, sauf) {
            for (let i = 0; i < array.length; i++) {
                if (i !== sauf && !array[i]) { return };
            }
            //console.log("testTousSauf", i, sauf, i!==sauf, typeof i, typeof sauf) ;   
            //for(let i in array) 
            return true;
        }
        for (const row of this.rows) {
            // console.log(index, row.data.col, row.tests.join(" "), testTousSauf(row.tests,index))
            if (testTousSauf(row.tests, index)) { each(row.data) }
        }
    }

}



class PrepareEtat {
    constructor(fonctionRegroupements, fonctionTri) {

        this.fonctionRegroupements = fonctionRegroupements.map(u => (typeof u === 'function') ? u : function (x) { return x[u] });
        if (typeof fonctionTri === 'function') {
            this.fonctionTri = fonctionTri;
        } else if (Array.isArray(fonctionTri)) {
            const fields = fonctionTri;
            this.fonctionTri = function (x) { 
                return fields.map(u=> x[u]).join('/');
            };
        } else {
            this.fonctionTri = function (x) { return x[fonctionTri] }
        }
    }
    construit(rows) {
        //
        const regroupements = this.fonctionRegroupements.map((f, index) => ({ set: new Set(), f: f, index: index }));
        const retour = [];
        //
        for (const row of rows) {
            const args = regroupements.map(regroupement => regroupement.f(row));
            //
            for (let index in regroupements) {
                const regroupement = regroupements[index];
                const key = args.slice(0, index + 1).join("/");
                //
                if (!regroupement.set.has(key)) {   // nouvel argument
                    regroupement.set.add(key);
                    //
                    retour.push(PrepareEtatItem(row, args, null, "A", index));
                    retour.push(PrepareEtatItem(row, args, null, "Z", index));
                }
            }
            const tri = this.fonctionTri(row);
            //console.log( tri);
            retour.push(PrepareEtatItem(row, args, tri));
            //
        }
        retour.sort(function (a, b) {
            // on trie suivant les arguments de regroupement, puis par le is, puis par l'argument de tri,
            let z;
            for (let index = 0; index < a.args.length; index++) {
                z = (a.args[index] ||'').localeCompare(b.args[index]);
                if (z) return z;
            }
            if (!a) return -1;
            if (!a.is) return -1;
            //
            z = a.is.localeCompare(b.is);
            if (z) return z;
            //
            if (!a.tri) return -1;
            z = a.tri.localeCompare(b.tri);
            return z;
        })
        return retour;
    }
}

export { PrepareEtat, JeuDeDonnees }
